import { Trigger } from './trigger';

export class Start{

  type:string = "Start";
  hash:string;
  trigger:Trigger;

  constructor(object = null){
    this.hash = "canvas-start";

    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.trigger){
      this.trigger = new Trigger(object.trigger);
      this.trigger.baseContent = this;
    }
  }

  isMainContent(){
    return false;
  }
  isSubContent(){
    return false;
  }

}